import PdfViewer from './PdfViewer'

export * from './PdfViewer'
export default PdfViewer
